export const challengerNameRules = [
  {
    required: true,
    message: 'Challenger Name cannot be empty.',
    whitespace: true
  },
  {
    min: 10,
    max: 255,
    message: 'Challenger Name must be 10 to 255 characters.'
  }
];

export const typologyDeselectRule = [
  {
    required: true,
    message: 'Reason for De-Selecting typologies cannot be empty.',
    whitespace: true
  },
  {
    min: 10,
    message:
      'Reason for De-Selecting typologies must be greater than 10 characters.'
  }
];

export const variantsDeselectRule = [
  {
    required: true,
    message: 'Reason for De-Selecting variants cannot be empty.',
    whitespace: true
  },
  {
    min: 10,
    message: 'Reason for De-Selecting variants must be greater than 10 characters.'
  }
];
